<script setup lang="ts">
import { PlusIcon } from "@heroicons/vue/20/solid";
import { Accordion as RadixAccordion } from "radix-vue/namespaced";
import { twMerge } from "tailwind-merge";

import { useUser } from "@/composables/api/useUser";

defineProps<{ label: string }>();
const { data: user } = useUser();
</script>

<template>
  <RadixAccordion.Item
    :value="label"
    class="flex flex-col gap-4 rounded-[20px] bg-white px-6 py-4 shadow-xl lg:py-5"
  >
    <RadixAccordion.Header class="flex w-full">
      <RadixAccordion.Trigger :asChild="true">
        <button
          type="button"
          :class="
            twMerge(
              `text-galbani flex w-full cursor-pointer items-center justify-between gap-4 data-[state='open']:[&>svg]:rotate-45`,
              user?.current_mechanic === 'lactel' && 'text-lactel-blue',
            )
          "
        >
          <span class="text-left text-lg leading-tight font-semibold lg:text-xl">{{ label }}</span>

          <PlusIcon class="size-6 shrink-0 transition-transform duration-300 ease-out lg:size-6" />
        </button>
      </RadixAccordion.Trigger>
    </RadixAccordion.Header>

    <RadixAccordion.Content
      class="accordion-content text-secondary flex flex-col gap-3 text-base font-medium lg:text-lg [&_a]:font-medium [&_a]:underline [&_ul]:list-disc [&_ul]:pl-6"
    >
      <slot />
    </RadixAccordion.Content>
  </RadixAccordion.Item>
</template>

<style lang="css" scoped>
@keyframes slide-down {
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}

@keyframes slide-up {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
}

.accordion-content {
  overflow: hidden;
}

.accordion-content[data-state="open"] {
  animation: slide-down 300ms ease-out;
}

.accordion-content[data-state="closed"] {
  animation: slide-up 300ms ease-out;
}
</style>
